// "Goes with it": when no Search & Discovery complementary list rendered server-side,
// fetch related products through the Section Rendering API and reuse the Liquid cards.
const controllers = new WeakMap();
const SEL = '[data-goes-with-it][data-url]';

export async function init(section) {
  if (section.dataset.recsInit) return;
  section.dataset.recsInit = '1';
  const ac = new AbortController();
  controllers.set(section, ac);
  try {
    const res = await fetch(section.dataset.url, { signal: ac.signal });
    if (!res.ok) return;
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const cards = doc.querySelectorAll('[data-recs-grid] .card');
    if (!cards.length) return;
    section.querySelector('[data-recs-grid]').replaceChildren(...cards);
    section.hidden = false;
  } catch (e) {
    /* aborted or failed: leave the section hidden */
  }
}

document.querySelectorAll(SEL).forEach(init);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll(SEL).forEach(init));
document.addEventListener('shopify:section:unload', (e) => {
  e.target.querySelectorAll(SEL).forEach((s) => { const c = controllers.get(s); if (c) c.abort(); });
});
